import { render, staticRenderFns } from "./AdvertisementsStates.vue?vue&type=template&id=05db0b8a&"
import script from "./AdvertisementsStates.vue?vue&type=script&lang=js&"
export * from "./AdvertisementsStates.vue?vue&type=script&lang=js&"
import style0 from "./AdvertisementsStates.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports